import { itemsInView, type IInViewContext, type IViewFilters } from '@d-orca/shared/client/activities';
import type { ISchedulerTask } from '@interfaces/IScheduler';
import type { IListItem } from '../model/listItem';

/** Whether an activity has areas — only those have a column in the matrix. */
export const hasAreas = (task: Pick<ISchedulerTask, 'locations'>): boolean => (task.locations?.length ?? 0) > 0;

/** The Status checkbox an activity answers to on the tracker: its PLAN status
 *  (Planned, Blocked, Done — the tracker keeps those, not the ladder's rungs;
 *  docs/specs/2026-09-22-work-plan-view-design.md). */
const planStatusOf = (item: IListItem): string => item.raw.activity!.status;

/**
 * The tracker's activities: the page's one "in view" selector (`itemsInView` —
 * the same filters, date window and stretched late spans the Daily List keeps
 * its activities by), in the tracker's Status vocabulary, then narrowed only
 * by what the tracker is — activities with areas, minus done work while its
 * own "hide 100%" toggle is on. The list's kind scope (All | Activities |
 * Issues) is not a filter and the tracker is activities only, so an Issues
 * scope carried over from the Daily List does not empty it.
 */
export function trackerActivities(
  activityItems: readonly IListItem[],
  filters: IViewFilters,
  context: Omit<IInViewContext, 'statusKey'>,
  hideDone: boolean,
): IListItem[] {
  return itemsInView(activityItems, { ...filters, types: [] }, { ...context, statusKey: planStatusOf }).filter((item) => {
    const task = item.raw.activity!;
    return hasAreas(task) && !(hideDone && task.progressPercent >= 100);
  });
}
